//七牛上传图片前缀
export const qiniuImgBaseUrl = "https://img.gotokepler.com/"

//七牛上传视频前缀
export const qiniuVideoBaseUrl = "https://video.joyami.com/"

//七牛上传路径（华东服务器）
export const qiniuUploadUrl_z0 = "https://upload.qiniup.com"

//七牛官网图片前缀
export const qiniuImgOffWebUrl = "https://img.gotokepler.com/image/gotokepler"

// jenkins目录路径
export const jen_configUrl = "/apps/cmros/"


// 社交媒体跳转链接
export const socialMediaUrl = {
    weibo: {
        name: '微博',
        account: '开普勒人形机器人',
        href: 'https://weibo.com/u/7873484312',
    },
    bili: {
        name: 'bilibili',
        account: '开普勒人形机器人',
        href: 'https://space.bilibili.com/3546393125849109',
    },
    youtube: {
        name: "Youtube",
        account: "Kepler Robot",
        href: "https://www.youtube.com/@KeplerRobot",
    },
    Instagram: {
        name: "Instagram",
        account: "gotokepler",
        href: "https://www.instagram.com/gotokepler/",
    },
    x: {
        name: "X",
        account: "Kepler Exploration Robotics",
        href: "https://twitter.com/BotKepler",
    },
    facebook: {
        name: "Facebook",
        account: "Kepler Exploration Robotics",
        href: "https://www.facebook.com/KeplerRobot",
    },
    linkedIn: { 
        name: 'linkedIn',
        account: 'gotokepler',
        href: 'https://www.linkedin.com/company/101394466/admin/dashboard/',
    },
}

// 用户协议
export const termsOfServiceUrl =  {
    'zh':{
        userAgreementUrl: 'https://img.gotokepler.com/subject/ec271bfac3ba49b3be43118f488f91fd.html',
        privacyPolicyUrl: 'https://img.gotokepler.com/subject/e27327f212de49989572c42d401a86c3.html'
    },
    'en':{
        userAgreementUrl: 'https://img.gotokepler.com/subject/02bb00147f4645f8bc3635dbc495caf4.html',
        privacyPolicyUrl: 'https://img.gotokepler.com/subject/b9d1b3989695458e83635758066611e9.html'
    },
}


// 仿真下载地址
export const Simulator_Download_Url = 'https://img.gotokepler.com/developer/resource/URDF.zip'